/**
 * @description 判斷付款人身分用
*/
export enum InsuredRoleType {
  /** 要保人 */
  Application = 'A',
  /** 被保人 */
  Insured = 'I'
}
